import React, { useState, useEffect } from "react";
import "./OnionBuy.css"; // Reuse the same CSS file, or create a new one if necessary.
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import Whyglobal from "../Components/Whyglobal";

// Random Seed Buyers Data (5 sample entries)
const SeedBuys = [
  {
    name: "Ravi Kumar",
    email: "ravi.kumar@example.com",
    mobileNumber: "+919876543210",
    locationandDate: "30-11-2024",
    lookingFor: "Required High-Quality Wheat Seeds in Bulk",
    productOrService: "Wheat Seeds",
    quantity: 5000,
    unit: "kg",
    _id: "668c0f639644befaa9548020",
  },
  {
    name: "Suresh Patel",
    email: "suresh.patel@example.com",
    mobileNumber: "+919883123456",
    locationandDate: "29-11-2024",
    lookingFor: "Looking for Hybrid Rice Seeds",
    productOrService: "Rice Seeds",
    quantity: 1500,
    unit: "kg",
    _id: "668c0f639644befaa9548021",
  },
  {
    name: "Neha Sharma",
    email: "neha.sharma@example.com",
    mobileNumber: "+919823456789",
    locationandDate: "28-11-2024",
    lookingFor: "Need Soybean Seeds for Plantation",
    productOrService: "Soybean Seeds",
    quantity: 3000,
    unit: "kg",
    _id: "668c0f639644befaa9548022",
  },
  {
    name: "Manoj Yadav",
    email: "manoj.yadav@example.com",
    mobileNumber: "+919893122233",
    locationandDate: "28-11-2024",
    lookingFor: "Required Organic Corn Seeds",
    productOrService: "Corn Seeds",
    quantity: 2500,
    unit: "kg",
    _id: "668c0f639644befaa9548023",
  },
  {
    name: "Priya Verma",
    email: "priya.verma@example.com",
    mobileNumber: "+919840011223",
    locationandDate: "25-11-2024",
    lookingFor: "Seeking Sunflower Seeds for Farm",
    productOrService: "Sunflower Seeds",
    quantity: 1200,
    unit: "kg",
    _id: "668c0f639644befaa9548024",
  },
];

const SeedBuy = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    // Load the viewed leads from local storage
    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`seedViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
        console.log("Premium Status:", data.isPremium);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return; // Only premium users can see numbers

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return; // If already shown, do nothing

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    // Update local storage
    localStorage.setItem(
      `seedViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = SeedBuys[index]; // Get the seed buyer information

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item"
          >
            <Link to={"/"}>Home</Link>
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px -25px",
            }}
          >
            /
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item active"
          >
            Fresh Leads
          </li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3 style={{ marginTop: "30px" }}>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Uttar Pradesh</Link>
            </li>
            <li>
              <Link to="#">Punjab</Link>
            </li>
            <li>
              <Link to="#">Madhya Pradesh</Link>
            </li>
            <li>
              <Link to="#">Rajasthan</Link>
            </li>
            <li>
              <Link to="#">Gujarat</Link>
            </li>
            <li>
              <Link to="#">Bihar</Link>
            </li>
          </ul>

          <ul style={{ marginTop: "20px" }} className="flt-list cust-scroll">
            <h3>All Category</h3>
            <li>
              <Link to="#">Wheat Seeds</Link>
            </li>
            <li>
              <Link to="#">Rice Seeds</Link>
            </li>
            <li>
              <Link to="#">Soybean Seeds</Link>
            </li>
            <li>
              <Link to="#">Corn Seeds</Link>
            </li>
            <li>
              <Link to="#">Sunflower Seeds</Link>
            </li>
          </ul>
        </div>
        <div className="buyers">
          {SeedBuys.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "red" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Date:</strong> {buyer.locationandDate}{" "}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                {userIsPremium && (
                  <button
                    className="detail-btn"
                    style={{
                      padding: "5px 10px",
                      background: "#f7f1f1",
                      color: "orange",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleNumber(index)}
                  >
                    Click to see
                  </button>
                )}
              </div>
              <div className="btns-imp">
                <Link to={"/login"}>
                  <button className="detailing-btn">View More</button>
                </Link>
                <Link to={"/register-Company"}>
                  <button className="regis-btn">Register Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="sidebar">
          <div className="mains-slide">
            <div className="tk23-hkCont_onergt">
              <div className="tk23-hkCont_premserv__box">
                <h1 className="tk23-hkCont_premserv__ttl">
                  Our Membership Plans
                </h1>
                <div className="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div className="tk23-hkCont_premservs">
                      <span
                        className="fontss"
                        style={{ backgroundColor: "#fff" }}
                      >
                        Standard Plan
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div className="tk23-hkCont_premservs">
                      <span
                        className="fontss"
                        style={{ backgroundColor: "#fff" }}
                      >
                        Advance Plan
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div className="tk23-hkCont_premservs">
                      <span
                        className="fontss"
                        style={{ backgroundColor: "#fff" }}
                      >
                        Premium Plan
                      </span>
                    </div>
                  </Link>
                  <Link to={"/packages"}>
                    <div className="reach">
                      <span className="reahhere">Call Now</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Whyglobal />
      </div>
    </>
  );
};

export default SeedBuy;
